import React, { useMemo } from 'react';
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend
} from 'chart.js';
import { Doughnut } from 'react-chartjs-2';

ChartJS.register(
  ArcElement,
  Tooltip,
  Legend
);

const DoughnutChart = ({ data }) => {
  const chartData = useMemo(() => {
    // Eski veri formatı kontrolü (labels ve counts içeren obje formatı)
    if (data && !Array.isArray(data) && data.labels && data.counts) {
      // Eski formatı yeni formata dönüştür
      const transformedData = data.labels.map((label, index) => ({
        name: label,
        count: data.counts[index]
      }));
      
      return {
        labels: transformedData.map(item => item.name),
        datasets: [
          {
            data: transformedData.map(item => item.count),
            backgroundColor: [
              'rgba(99, 102, 241, 0.7)',
              'rgba(239, 68, 68, 0.7)',
              'rgba(59, 130, 246, 0.7)',
              'rgba(16, 185, 129, 0.7)',
              'rgba(245, 158, 11, 0.7)',
              'rgba(139, 92, 246, 0.7)',
              'rgba(236, 72, 153, 0.7)',
              'rgba(55, 65, 81, 0.7)',
            ],
            borderColor: [
              'rgba(99, 102, 241, 1)',
              'rgba(239, 68, 68, 1)',
              'rgba(59, 130, 246, 1)',
              'rgba(16, 185, 129, 1)',
              'rgba(245, 158, 11, 1)',
              'rgba(139, 92, 246, 1)',
              'rgba(236, 72, 153, 1)',
              'rgba(55, 65, 81, 1)',
            ],
            borderWidth: 1,
          },
        ],
      };
    }

    // Standart dizi kontrolü
    if (!data || !Array.isArray(data) || data.length === 0) {
      return {
        labels: ['Veri Yok'],
        datasets: [
          {
            data: [1],
            backgroundColor: ['rgba(209, 213, 219, 0.5)'],
            borderColor: ['rgba(209, 213, 219, 1)'],
            borderWidth: 1,
          },
        ],
      };
    }

    return {
      labels: data.map(item => item.name),
      datasets: [
        {
          data: data.map(item => item.count),
          backgroundColor: [
            'rgba(99, 102, 241, 0.7)',
            'rgba(239, 68, 68, 0.7)',
            'rgba(59, 130, 246, 0.7)',
            'rgba(16, 185, 129, 0.7)',
            'rgba(245, 158, 11, 0.7)',
            'rgba(139, 92, 246, 0.7)',
            'rgba(236, 72, 153, 0.7)',
            'rgba(55, 65, 81, 0.7)',
          ],
          borderColor: [
            'rgba(99, 102, 241, 1)',
            'rgba(239, 68, 68, 1)',
            'rgba(59, 130, 246, 1)',
            'rgba(16, 185, 129, 1)',
            'rgba(245, 158, 11, 1)',
            'rgba(139, 92, 246, 1)',
            'rgba(236, 72, 153, 1)',
            'rgba(55, 65, 81, 1)',
          ],
          borderWidth: 1,
        },
      ],
    };
  }, [data]);

  const options = useMemo(() => {
    let totalStudents = 0;
    
    // Eski veri formatı kontrolü
    if (data && !Array.isArray(data) && data.counts) {
      totalStudents = data.counts.reduce((total, count) => total + count, 0);
    }
    // Yeni veri formatı (dizi) kontrolü
    else if (Array.isArray(data)) {
      totalStudents = data.reduce((total, item) => total + (item.count || 0), 0);
    }

    return {
      responsive: true,
      maintainAspectRatio: true,
      plugins: {
        legend: {
          position: 'right',
          align: 'center',
          labels: {
            usePointStyle: true,
            pointStyle: 'circle',
            boxWidth: 8,
            padding: 15,
            font: {
              size: 11
            }
          }
        },
        tooltip: {
          backgroundColor: 'rgba(0, 0, 0, 0.8)',
          titleColor: 'rgba(255, 255, 255, 1)',
          bodyColor: 'rgba(255, 255, 255, 1)',
          padding: 12,
          callbacks: {
            label: function(context) {
              const label = context.label || '';
              const value = context.raw || 0;
              const percentage = totalStudents > 0 ? Math.round((value / totalStudents) * 100) : 0;
              return `${label}: ${value} öğrenci (${percentage}%)`;
            }
          }
        }
      },
      cutout: '65%',
    };
  }, [data]);

  return (
    <div className="bg-white p-4 rounded-lg shadow-sm border border-gray-100 h-full">
      <h3 className="text-lg font-semibold text-gray-800 mb-4 flex items-center">
        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2 text-indigo-500" viewBox="0 0 20 20" fill="currentColor">
          <path fillRule="evenodd" d="M4 2a2 2 0 00-2 2v11a3 3 0 106 0V4a2 2 0 00-2-2H4zm1 14a1 1 0 100-2 1 1 0 000 2zm5-1.757l4.9-4.9a2 2 0 000-2.828L13.485 5.1a2 2 0 00-2.828 0L10 5.757v8.486zM16 18H9.071l6-6H16a2 2 0 012 2v2a2 2 0 01-2 2z" clipRule="evenodd" />
        </svg>
        Sınıf Dağılımı
      </h3>
      <div className="h-[280px] flex items-center justify-center">
        {(!data || 
          (Array.isArray(data) && data.length === 0) || 
          (!Array.isArray(data) && (!data.labels || !data.counts || data.labels.length === 0))) ? (
          <div className="text-center text-gray-500">
            <p>Sınıf dağılımı verisi bulunamadı</p>
          </div>
        ) : (
          <Doughnut data={chartData} options={options} />
        )}
      </div>
    </div>
  );
};

export default DoughnutChart;